module.exports = __webpack_public_path__ + "media/T03.18c65476.mp4";